import styled from 'styled-components';

export const OptionRow = styled.div`
  color: ${({ theme }) => theme.defaultColors.fontSecondary};
  margin-bottom: 20px;
  font-size: 15px;
`;
